let options = {
    root: null,
    threshold: 1,
    rootMargin: `0px 0px -200px 0px`,
  };


let callback = (entries, observer) => {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
            entry.target.classList.add('active');
            observer.observe(entry.target);
        }
        console.log(entry.intersectionRatio);
    });
  };
  
let observer = new IntersectionObserver(callback, options);
let target = document.querySelectorAll('.top-piece');

target.forEach(target => {
    observer.observe(target);
});